<template>
  <div class="set-password-container">
    <el-card class="password-card">
      <div slot="header" class="card-header">
        <h2>Set Your Password</h2>
        <p>This is your first login, please set a secure password</p>
      </div>

      <el-form :model="fromData" :rules="rules" ref="passwordForm" label-position="top">
        <el-form-item label="Email">
          <el-input v-model="fromData.email" disabled></el-input>
        </el-form-item>

        <el-form-item label="Password" prop="password">
          <el-input v-model="fromData.password" type="password" show-password placeholder="Enter your password"></el-input>
        </el-form-item>

        <el-form-item label="Confirm Password" prop="password_confirmation">
          <el-input v-model="fromData.password_confirmation" type="password" show-password
            placeholder="Re-enter your password"></el-input>
        </el-form-item>

        <el-form-item>  
          <el-button type="primary" @click="submitForm" style="width: 100%">Confirm</el-button>
        </el-form-item>

      </el-form>
    </el-card>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { amendPassword } from '@/api/auth';

export default {
  name: 'SetPassword',
  data() {
    return {
      fromData: {
        // token: '',
        password: '',
        email: '',
        password_confirmation: ''
      },
      rules: {
        password: [{ validator: this.validatePassword, trigger: 'blur' }],
        password_confirmation: [{ validator: this.validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  created() {
    this.fromData.email = localStorage.getItem("email");
    this.fromData.token = localStorage.getItem("token");
  },
  methods: {
    validateConfirmPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please re-enter your password'));
      } else if (value !== this.fromData.password) {
        callback(new Error('The passwords do not match!'));
      } else {
        callback();
      }
    },
    validatePassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('Please enter a password'));
      } else if (value.length < 8) {
        callback(new Error('The password must be at least 8 characters long'));
      } else {
        if (this.fromData.password_confirmation !== '') {
          this.$refs.passwordForm.validateField('password_confirmation');
        }
        callback();
      }
    },
    async submitForm() {
      try {
        // 1. 验证表单
        await this.$refs.passwordForm.validate();

        // 2. 检查空值和空白字符
        if (!this.fromData.password.trim()) {
          this.$message.error('Password cannot be empty or whitespace');
          return;
        }

        // 3. 加密提交
        const encryptedData = {
          password: CryptoJS.SHA256(this.fromData.password.trim()).toString(),
          password_confirmation: CryptoJS.SHA256(this.fromData.password_confirmation.trim()).toString()
        };

        const res = await amendPassword(encryptedData);
        if (res.success) {
          this.$notify({
            title: 'Succeed',
            message: res.message,
            type: 'success'
          });
          // 成功后跳转到 /user
          this.$router.push('/user');
        }
        // ...处理响应
      } catch (error) {
        if (error !== 'ValidationError') {
          this.$notify.error({
            title: 'Error',
            message: error.response?.data?.message || 'Password update failed'
          });
        }
      }
    }
  }
}
</script>

<style scoped>
.set-password-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.password-card {
  width: 400px;
  max-width: 90%;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  margin-bottom: 10px;
}

.card-header p {
  color: #909399;
  font-size: 14px;
}
</style>
